import { helper } from '@ember/component/helper';

export default helper(function plusOne(positional /*, named*/) {
  if (positional.length != 1) {
    return positional;
  }
  return +positional[0] + 1;
});
